export function topBannerCarousel(blockId, autoplaySpeed = 5) {
    $(`#${blockId}`).slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: autoplaySpeed * 1000,
        arrows: false,
        dots: true,
        fade: true,
        swipe: true,
        speed: 600,
    });
}
